import { connectRouter, routerMiddleware } from "connected-react-router";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { History } from "history";
import { composeWithDevTools } from "redux-devtools-extension";
import { createLogicMiddleware } from "redux-logic";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { StateType } from "typesafe-actions";
import { accountReducer } from "./Account/reducers";
import { appStateReducer } from "./AppState/reducers";
import arrLogic from "./logic";

const createAppReducer = (history: History) =>
	combineReducers({
		app: appStateReducer,
		accounts: accountReducer
	});

const createRootReducer = (history: History) => (state: any, action: any) => {
	return createAppReducer(history)(state, action);
};

const persistConfig = {
	key: "root",
	storage,
	blacklist: ["accounts", "app"]
};

const persistedReducer = (history: History) => persistReducer(persistConfig, createRootReducer(history));

const logicDeps = {};

const logicMiddleware = createLogicMiddleware(arrLogic, logicDeps);

export type AppState = ReturnType<typeof persistedReducer>;

export type RootState = StateType<ReturnType<typeof persistedReducer>>;
export interface TypedUseSelectorHook {
	<TSelected>(selector: (state: RootState) => TSelected, equalityFn?: (left: TSelected, right: TSelected) => boolean): TSelected;
}

export default function configureStore(history: History) {
	const middlewares = [logicMiddleware, routerMiddleware(history)];
	const middleWareEnhancer = applyMiddleware(...middlewares);

	const store = createStore(persistedReducer(history), composeWithDevTools(middleWareEnhancer));
	const persistor = persistStore(store);

	return { store, persistor };
}
